import firebase from 'firebase/app';

import { ROUTER_PATHS } from '../constants';

export default (router) =>
  firebase.auth().onAuthStateChanged((user) => {
    if (!user && router.currentRoute.path !== ROUTER_PATHS.LOGIN && router.currentRoute.meta.safe) {
      router.push(ROUTER_PATHS.LOGIN);
    }
  });
